import { Link } from "react-router-dom";
import { Section, ghostButton } from "@/components/settings/primitives";
import { formatNumber } from "@/lib/format";

export function UsageSection({ me }) {
  const c = me.credits;
  return (
    <Section title="Usage" description="Your prepaid credits and recent usage." testId="settings-usage-section">
      <dl className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {[
          ["Billing", "Prepaid credits"],
          ["Credits remaining", formatNumber(c.balance)],
          ["Used this month", formatNumber(c.used)],
        ].map(([k, v]) => (
          <div key={k}>
            <dt className="text-xs text-zinc-500">{k}</dt>
            <dd className="mt-1 text-sm font-medium text-white" data-testid={`settings-usage-${k.toLowerCase().replace(/\s+/g, "-")}`}>{v}</dd>
          </div>
        ))}
      </dl>
      <Link to="/plan" className={`${ghostButton} mt-6`} data-testid="settings-usage-link">
        Open Plan & Usage
      </Link>
    </Section>
  );
}
